import React, { useEffect } from "react";
import SubscriptionHeroImg from "../Assets/img/w-subscription-hero-img.svg";
import PricingTable from "../Components/PricingTable";
import SoftwareFeatures from "../Components/SoftwareFeatures";

const WebSubscription = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <!-- Hero-Area --> */}
      <section className="a-isp-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="a-isp-content">
                <h1>ISP Digital Pricing</h1>
                <p>
                  As we are working with the ISP industry for a long time and
                  have successfully contributed to ISP businesses, We understand
                  the story behind each business and its value. To accurately
                  assess your hard-earned money, bring cost-effectiveness, and
                  meet your company's needs, we have divided the ISP Digital
                  software into three categories.m turpis sollicitudin blandit
                  massa ornare facilisi.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="a-isp-img">
                <img src={SubscriptionHeroImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End-Hero-Area -->	 */}
      <PricingTable />
      <SoftwareFeatures />
    </>
  );
};

export default WebSubscription;
